import smartlookClient from 'smartlook-client';

import { SMARTLOOK_API } from './settings';

const configureSmartlook = () => smartlookClient.init(SMARTLOOK_API);

export default configureSmartlook;
